export default __webpack_public_path__ + "static/KeremHulbert-03d006ee5c63131c519f77aa89578602.png";